import {
  Booking,
  Guests as BoVioGuests,
  MethodObject as BoVioMethodObject,
  Payment as BoVioPayment,
  Price as BoVioPrice,
  Refund as BoVioRefund,
  Room as BoVioRoom
} from '../../api-types/bovio/response/booking'

/**
 * Do not modify the following types directly.
 * These types are extended from auto-generated types from the BoVIO API .
 * If any changes or additions properties are needed, please update the corresponding schemas
 * in the Back-end API first, and then regenerate these types.
 */
export interface BookingData extends Booking {}

export interface Refund extends BoVioRefund {}

export interface Room extends BoVioRoom {}

export interface Guests extends BoVioGuests {}

export interface BookingOfferPrice extends BoVioPrice {}

export interface Payment extends BoVioPayment {}

export interface MethodObject extends BoVioMethodObject {}

export enum BookingSources {
  Default = 'default',
  DealFreeze = 'deal_freeze',
  Rebooking = 'rebooking',
  ChargeLater = 'charge_later',
  PayAtProperty = 'pay_at_property'
}

export interface OfferMetadata {
  accessTier: string[]
}
